// eslint-disable-next-line import/prefer-default-export
export const enableMutationFnDefaultParams = { enableMutationFn: () => true };
